// remember this is not the same as NODE_ENV!
export enum Environ {
  // special case for local development only
  LOCAL = "local",

  // special case for JEST unit tests only
  TEST = "test",

  // these below are set in ansible only
  DEV = "dev", //= test center
  STAGING = "staging",
  PROD = "prod",
}

// and these actually define the runtime mode of node.js and are
// set either in package.json, via Jest or in the Dockerfile
export enum NodeEnvType {
  PRODUCTION = "production",
  DEVELOPMENT = "development",
  TEST = "test",
}
